/* Organised play EOI form.
 *
 * Progressive enhancement over Shopify's native customer form. On submit
 * it (1) refuses to go on with no slot ticked, (2) joins the ticked chips
 * into the single hidden contact[tags] field, and (3) prefixes the
 * comment with the game, slots and formats so the customer note reads on
 * its own.
 *
 * It must NOT preventDefault on the happy path and must NOT post via
 * fetch. Spam protection is on for this store, and only a native submit
 * gets the hCaptcha token — anything else is rejected with "Missing
 * CAPTCHA token". Shopify's captcha script may resubmit the form itself,
 * so the note rebuild is idempotent: it always starts from the comment
 * the person typed, never from an already-prefixed value.
 *
 * Without this script the hidden tags field still posts
 * op-eoi,op-game-<slug> and the comment posts unprefixed.
 */
(function () {
  'use strict';

  function setup(root) {
    var form = root.querySelector('form');
    var tagsEl = root.querySelector('[data-op-tags]');
    var noteEl = root.querySelector('[data-op-note]');
    var slotsEl = root.querySelector('[data-op-slots]');
    var slotsErr = root.querySelector('[data-op-slots-error]');

    if (!form || !tagsEl) return;

    var gameTag = root.getAttribute('data-game-tag') || '';
    var gameName = root.getAttribute('data-game-name') || '';
    var typedComment = null;

    function checked(scope) {
      return Array.prototype.slice.call(
        scope.querySelectorAll('input[type="checkbox"][data-tag]:checked')
      );
    }

    function labels(boxes) {
      return boxes
        .map(function (box) { return box.getAttribute('data-label') || ''; })
        .filter(Boolean)
        .join(', ');
    }

    form.addEventListener('submit', function (event) {
      var slots = slotsEl ? checked(slotsEl) : [];

      if (slotsEl && !slots.length) {
        event.preventDefault();
        if (slotsErr) slotsErr.hidden = false;
        slotsEl.classList.add('is-invalid');
        var first = slotsEl.querySelector('input[type="checkbox"]');
        if (first) first.focus();
        return;
      }

      var all = checked(form);
      var tags = ['op-eoi'];
      if (gameTag) tags.push(gameTag);
      all.forEach(function (box) { tags.push(box.getAttribute('data-tag')); });
      tagsEl.value = tags.join(',');

      if (!noteEl) return;
      if (typedComment === null) typedComment = noteEl.value.trim();

      var formats = all.filter(function (box) {
        return (box.getAttribute('data-tag') || '').indexOf('op-format-') === 0;
      });

      var parts = [gameName, labels(slots), labels(formats), typedComment];
      noteEl.value = parts.filter(Boolean).join(' · ');
    });

    if (slotsEl) {
      slotsEl.addEventListener('change', function () {
        if (!checked(slotsEl).length) return;
        if (slotsErr) slotsErr.hidden = true;
        slotsEl.classList.remove('is-invalid');
      });
    }

    if (noteEl) {
      noteEl.addEventListener('input', function () { typedComment = null; });
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-op-eoi]'), setup);
})();
